import { useEffect, useState } from "react";
import { Phone, ArrowUp } from "lucide-react";
import { COMPANY } from "@/data/content";
import { useLocale } from "@/i18n/LocaleContext";
import WhatsAppIcon from "@/components/site/WhatsAppIcon";
import { whatsappHref } from "@/lib/whatsapp";

const SHOW_TOP_AFTER = 600;

// Schwebende Aktionen rechts unten: WhatsApp (immer), Anrufen (mobil),
// Nach oben (ab xl). Als Spalte gestapelt, damit nichts überlappt.
export const FloatingActions = () => {
  const [showTop, setShowTop] = useState(false);
  const { t } = useLocale();
  const waHref = whatsappHref(t.common.whatsappText);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > SHOW_TOP_AFTER);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 end-5 z-40 flex flex-col items-end gap-3">
      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="scroll-to-top"
          aria-label={t.floating.toTop}
          className="hidden xl:inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand text-white shadow-lg hover:bg-brand-dark active:scale-95 transition-all focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand/40"
        >
          <ArrowUp className="w-6 h-6" />
        </button>
      )}

      {waHref && (
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-button"
          aria-label={t.floating.whatsappLabel}
          title={t.floating.whatsappLabel}
          className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:bg-[#1FB855] active:scale-95 transition-all focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#25D366]/50"
        >
          <WhatsAppIcon className="w-7 h-7" />
        </a>
      )}

      <a
        href={`tel:${COMPANY.phoneRaw}`}
        data-testid="floating-call-button"
        aria-label={`${t.floating.callLabel} ${COMPANY.phone}`}
        className="xl:hidden inline-flex items-center gap-2 rounded-full bg-coral px-5 py-4 text-white font-600 shadow-[0_10px_30px_rgba(161,48,60,0.5)] active:scale-95 transition-transform focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-coral/50"
      >
        <Phone className="w-6 h-6" strokeWidth={2} />
        {t.common.call}
      </a>
    </div>
  );
};

export default FloatingActions;
